/**
 * App-wide constants.
 * Intentionally tiny — only the values the whole app needs to reference.
 */

// Cloudflare Worker base URL.
//
// In production (deployed under dashboards.common-trust.com/wbr/), we
// talk to the worker via a same-origin /api/* path. That path is served
// by a Worker Route bound to the ct-hubspot-proxy worker, which means:
//   - Cloudflare Access can sit in front of the whole domain
//   - Browsers send the CF_Authorization cookie with each fetch
//   - The worker receives Cf-Access-Authenticated-User-Email for /whoami
//
// In dev (localhost:5174), there's no Access in front, so we hit the
// worker's bare .workers.dev URL directly.
export const API_BASE = import.meta.env.PROD
  ? '/api'
  : 'https://ct-hubspot-proxy.secure-accounts-468.workers.dev'

// localStorage key used by the current dashboard — we read this as a
// fallback if the worker is unreachable.
export const LEGACY_STORAGE_KEY = 'ct-goals-q2-2026-v14'
